import { Placement } from '@popperjs/core'
import { Tooltip } from '@positivote/design-system/components/Tooltip'
import { useTheme } from '@positivote/design-system/hooks'
import { AlertErrorIcon } from '@positivote/design-system/icons/AlertError'
import { CheckCircleIcon } from '@positivote/design-system/icons/CheckCircle'
import { Breakpoint } from '@positivote/design-system/theme'
import { useEffect } from 'react'

import { i18n } from '@/common/i18n'
import { useShowServicesStatus } from '@/modules/requirements/hooks'

import { AccordionRequirements } from './AccordionRequirements'

export interface AccordionServicesProps {
  onChangeServicesInfos: (infos: { service: string; database: string }) => void
}

export function AccordionServices({ onChangeServicesInfos }: AccordionServicesProps): JSX.Element {
  const showServiceStatus = useShowServicesStatus({})
  const { breakpoint } = useTheme()

  const tooltipPlacement: Placement = breakpoint >= Breakpoint.lg ? 'right' : 'left'

  const isServicesHub = showServiceStatus.data?.status === 'ONLINE'
  const isServicesDb = showServiceStatus.data?.services.find(
    (services) => services.serviceName === 'db'
  )?.status

  useEffect(() => {
    onChangeServicesInfos({
      database: isServicesDb
        ? i18n().modules.requirements.components.accordionServices.accessible
        : i18n().modules.requirements.components.accordionServices.inaccessible,
      service: isServicesHub
        ? i18n().modules.requirements.components.accordionServices.accessible
        : i18n().modules.requirements.components.accordionServices.inaccessible
    })
    // DOCS: This useeffect can only be used when changing states
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showServiceStatus.data])

  return (
    <AccordionRequirements
      requirementsProps={{
        title: i18n().modules.requirements.components.accordionServices.title,
        descriptions: [
          {
            key: 'hubService',
            label: i18n().modules.requirements.components.accordionServices.service,
            value: isServicesHub
              ? i18n().modules.requirements.components.accordionServices.accessible
              : i18n().modules.requirements.components.accordionServices.inaccessible,
            icon: isServicesHub ? (
              <CheckCircleIcon fill="$success" />
            ) : (
              <Tooltip
                label={i18n().modules.requirements.components.accordionServices.inaccessible}
                placement={tooltipPlacement}
                arrow
              >
                <AlertErrorIcon fill="$critical" />
              </Tooltip>
            )
          },
          {
            key: 'hubDatabase',
            label: i18n().modules.requirements.components.accordionServices.database,
            value: isServicesDb
              ? i18n().modules.requirements.components.accordionServices.accessible
              : i18n().modules.requirements.components.accordionServices.inaccessible,
            icon: isServicesDb ? (
              <CheckCircleIcon fill="$success" />
            ) : (
              <Tooltip
                label={i18n().modules.requirements.components.accordionServices.inaccessible}
                placement={tooltipPlacement}
                arrow
              >
                <AlertErrorIcon fill="$critical" />
              </Tooltip>
            )
          }
        ]
      }}
      isLoading={showServiceStatus.isLoading}
    />
  )
}
